export default [
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('@/views/Mine/Index'),
    meta: {
      roles: ['distributor', 'customer'],
    },
    children: [
      {
        path: 'setting',
        name: 'Setting',
        component: () => import('@/views/Setting/Index'),
        meta: {
          roles: ['distributor', 'customer'],
        },
        children: [
          {
            path: 'baseInfo',
            name: 'SettingBaseInfo',
            component: () => import('@/views/Setting/BaseInfo'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
          {
            path: 'invoice',
            name: 'SettingInvoice',
            component: () => import('@/views/Setting/Invoice'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
          {
            path: 'address',
            name: 'SettingAddress',
            component: () => import('@/views/Setting/Address'),
            meta: {
              roles: ['distributor', 'customer'],
            },
            children: [
              {
                path: 'create',
                name: 'SettingAddressCreate',
                component: () => import('@/views/Setting/Address/create'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
              },
            ],
          },
          {
            path: 'safe',
            name: 'SettingSafe',
            component: () => import('@/views/Setting/Safe'),
            meta: {
              roles: ['distributor', 'customer'],
            },
            children: [
              {
                path: 'pwd',
                name: 'SettingSafePwd',
                component: () => import('@/views/Setting/Safe/pwd'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
                children: [
                  {
                    path: 'code',
                    name: 'SettingSafePwdCode',
                    component: () => import('@/views/Setting/Safe/code'),
                    meta: {
                      roles: ['distributor', 'customer'],
                    },
                  },
                ],
              },
              {
                path: 'payPwd',
                name: 'SettingSafePayPwd',
                component: () => import('@/views/Setting/Safe/payPwd'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
                children: [
                  {
                    path: 'code',
                    name: 'SettingSafePayPwdCode',
                    component: () => import('@/views/Setting/Safe/code'),
                    meta: {
                      roles: ['distributor', 'customer'],
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'settingInviteCode',
            name: 'SettingInviteCode',
            component: () => import('@/views/Setting/InviteCode'),
            meta: {
              roles: ['customer'],
            },
          },
          {
            path: 'settingAboutUs',
            name: 'SettingAboutUs',
            component: () => import('@/views/Setting/AboutUs'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
        ],
      },
      {
        path: 'wallet',
        name: 'Wallet',
        component: () => import('@/views/Wallet/Index'),
        meta: {
          roles: ['distributor', 'customer'],
        },
        children: [
          {
            path: 'withdraw',
            name: 'WalletWithdraw',
            component: () => import('@/views/Wallet/Withdraw'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
          {
            path: 'account-detail',
            name: 'WalletAccountDetail',
            component: () => import('@/views/Wallet/AccountDetail'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
          {
            path: 'record',
            name: 'WalletRecord',
            component: () => import('@/views/Wallet/Record'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
        ],
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import('@/views/Order/Index'),
        meta: {
          roles: ['distributor', 'customer'],
        },

        children: [
          //支付完成路由
          {
            path: 'payComplete',
            name: 'payComplete',
            component: () => import('@/views/Order/payComplete'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },

          {
            path: 'afterSale',
            name: 'OrderAfterSale',
            component: () => import('@/views/Order/AfterSale'),
            meta: {
              roles: ['distributor', 'customer'],
            },
            children: [
              {
                path: 'goods-detail',
                name: 'OrderAfterSaleGoodsDetail',
                component: () => import('@/views/Order/AfterSale/goodsDetail'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
              },
              {
                path: 'logistics',
                name: 'OrderAfterSaleLogistics',
                component: () => import('@/views/Order/AfterSale/logistics'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
              },
              {
                path: 'locus',
                name: 'OrderAfterSaleLocus',
                component: () => import('@/views/Order/AfterSale/locus'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
              },
            ],
          },
          {
            path: 'logistics',
            name: 'OrderAfterSaleLogistics_',
            component: () => import('@/views/Order/AfterSale/logistics'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
          {
            path: 'inSale',
            name: 'OrderInSale',
            component: () => import('@/views/Order/InSale'),
            meta: {
              roles: ['distributor', 'customer'],
            },
            children: [
              {
                path: 'goods-detail',
                name: 'OrderInSaleGoodsDetail',
                component: () => import('@/views/Order/InSale/goodsDetail'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
              },
              {
                path: 'invoice',
                name: 'InSaleInvoiceSimple',
                component: () => import('@/views/Order/InSale/invoiceSimple'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
              },

              {
                path: 'locus',
                name: 'OrderInSaleLocus',
                component: () => import('@/views/Order/InSale/locus'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
              },
              {
                path: 'chooseAftSaleGoods/:id',
                name: 'ChooseAftSaleGoods',
                component: () =>
                  import('@/views/Order/InSale/chooseAftSaleGoods'),
                meta: {
                  roles: ['distributor', 'customer'],
                },
                children: [
                  {
                    path: 'applyAftSale',
                    name: 'ApplyAftSale',
                    component: () =>
                      import('@/views/Order/InSale/applyAftSale'),
                    meta: {
                      roles: ['distributor', 'customer'],
                    },
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        path: 'coupon',
        name: 'Coupon',
        component: () => import('@/views/Coupon/index'),
        meta: {
          roles: ['distributor', 'customer'],
        },
      },

      {
        path: 'CouponCenter',
        name: 'CouponCenter',
        component: () => import('@/views/Coupon/center'),
        meta: {
          roles: ['distributor', 'customer'],
        },
      },
      {
        path: 'redpack',
        name: 'Redpack',
        component: () => import('@/views/Redpack/index'),
        meta: {
          roles: ['distributor', 'customer'],
        },
      },
      {
        path: 'RedpackCenter',
        name: 'RedpackCenter',
        component: () => import('@/views/Redpack/center'),
        meta: {
          roles: ['distributor', 'customer'],
        },
      },
      {
        path: 'message',
        name: 'MineMessage',
        component: () => import('@/views/Message'),
        meta: {
          roles: ['distributor', 'customer'],
        },
        children: [
          {
            path: 'messageDetail',
            name: 'MineMessageDetail',
            component: () => import('@/views/Message/detail'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
        ],
      },
      {
        path: 'followingAct',
        name: 'FollowingAct',
        component: () => import('@/views/FollowingAct'),
        meta: {
          roles: ['distributor', 'customer'],
        },
      },
      {
        path: 'followingBrand',
        name: 'FollowingBrand',
        component: () => import('@/views/FollowingBrand'),
        meta: {
          roles: ['distributor', 'customer'],
        },
      },
      {
        path: 'history',
        name: 'History',
        component: () => import('@/views/History'),
        meta: {
          roles: ['distributor', 'customer'],
        },
        children: [
          {
            path: 'goodsDetail/:id',
            name: 'HistoryGoodsDetail',
            component: () => import('@/views/GoodsDetail'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
        ],
      },
      {
        path: 'like',
        name: 'MineLike',
        component: () => import('@/views/Mine/Like'),
        meta: {
          roles: ['distributor'],
        },
      },
    ],
  },
]
